import { MEMBERS_LIST_PAGE_SIZE } from "@/config/constants";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getMembersWithPrefixSearch } from "../members";

export interface SearchedContact {
  username: string;
  avatar: string;
  // role: MemberRole;
}

interface UsePaginatedMembersOptions {
  count?: number; // Results per page
  searchTerm: string;
  member?: string; // pass chatId - gets members INSIDE that chat
  not_member?: string; // pass chatId - gets members OUTSIDE that chat
}

export function usePaginatedMembersWithPrefixSearch({
  count = MEMBERS_LIST_PAGE_SIZE,
  searchTerm,
  member,
  not_member,
}: UsePaginatedMembersOptions) {
  // Set up the infinite query
  const {
    data,
    status,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: ["search-members", searchTerm, member],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await getMembersWithPrefixSearch(
        searchTerm,
        pageParam,
        count,
        member,
        not_member,
      );
      return response;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < count) {
        return undefined;
      }
      return allPages.length * count;
    },
    initialPageParam: 0, // initial offset skip
    // Only enable the query if there is a search term.
    enabled: !!searchTerm,
    // TO DO => To be configured later based on estimated usage and best performance
    // staleTime: 60000,
    // gcTime: 1000, // Inactive queries are garbage collected after 5 minutes by default.
    // refetchInterval: 10000,
    // refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    data,
    status,
    isFetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    error,
  };
}
